/**
 * Newsletter notification configuration.
 */

export const NEWSLETTER_NOTIFICATION_COOKIE = "hideNewsletterNotification";
// 10 years - effectively permanent
export const NEWSLETTER_COOKIE_EXPIRY_DAYS = 3650;

// Set to false to disable the newsletter notification entirely.
export const ENABLE_NEWSLETTER_NOTIFICATION = true;
